import React from 'react';

export const Footer = () => {
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/5aef0a8df517b865df3c53c45a2fd1ff726cf5f808670b49edd6820a48780cae68c41714c5c531fe697e77aede0c0572/images/aW1hZ2UvcG5n/e9d3e7f741f9e0014af0919c3d6c8e4d.png";
  return (
    <footer className="w-full py-8 mt-auto flex flex-col items-center justify-center gap-2 z-10 relative">
      <img 
        src={logoUrl} 
        alt="Do You Know Me?" 
        className="h-5 sm:h-6 w-auto object-contain opacity-40 hover:opacity-100 transition-opacity duration-300" 
      />
      <span className="text-[10px] font-bold text-slate-600 uppercase tracking-widest">
        Build v1.1.1 • Live Sync Active
      </span>
    </footer>
  );
};